'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var _require = require('./options');

var TYPES = _require.TYPES;
var SIZES = _require.SIZES;

var Icon = function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Icon.prototype.render = function render() {
    var className = 'cf-icon cf-icon--' + this.props.type;

    if (this.props.size) {
      className += ' cf-icon--' + this.props.size;
    }

    if (this.props.border) className += ' cf-icon--border';
    if (this.props.spin) className += ' cf-icon--spin';
    if (this.props.muted) className += ' cf-icon--muted';
    if (this.props.white) className += ' cf-icon--white';

    return React.createElement(
      'i',
      { className: className },
      this.props.label && React.createElement(
        'span',
        { className: 'cf-icon__label' },
        this.props.label
      )
    );
  };

  return Icon;
}(React.Component);

Icon.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]).isRequired,
  type: PropTypes.oneOf(TYPES).isRequired,
  size: PropTypes.oneOf(SIZES),
  border: PropTypes.bool,
  spin: PropTypes.bool,
  muted: PropTypes.bool,
  white: PropTypes.bool
};
;

module.exports = Icon;